import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CardBody, Modal } from "reactstrap";
import { useNavigate } from "react-router-dom";
import CardHeader from "../../Common/CardHeader/CardHeader";
import search from "../../assets/images/search-lg.svg";
import {
  deleteOneInvoice,
  getInvoiceList,
  updateInvoiceAccountingClassification,
} from "../../../redux/invoice/action";
import swal from "sweetalert";
import Check from "../../assets/images/checkk.svg";
import Cross from "../../assets/images/cross.svg";
import CommonPagination from "../../Common/Pagination/CommonPagination";
import FullScreenLoader from "../../Layouts/FullScreenLoader/FullScreenLoader";
import DeleteInvoices from "./DeleteInvoices";
import InvoiceFilters from "./InvoiceFilters";
import ZatcaModals from "./ZatcaModals";

const InvoiceLists = () => {
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const [modals, setModals] = useState(false);
  const [zatcaMod, setZatcaMod] = useState(false);
  const [zatDetails, setZatDetails] = useState(null);
  const [isloading, setIsLoading] = useState(true);

  const navigate = useNavigate();
  const [openFilter, setOpenFilter] = useState(false);
  const [currentComponent, setCurrentComponent] = useState({});

  const [params, setParams] = useState({
    search_key: "",
    page: 1,
    user_id: 1,
    start_date: "",
    end_date: "",
    status: "",
    invoice_type: "",
    testing_account_filter: "hide",
    accounting_document_filter: "all",
  });
  const invoiceList = useSelector((state) => state?.reusableSlice?.invoiceList);

  useEffect(() => {
    dispatch(getInvoiceList(params))
      .then((res) => {
        if (res.status) {
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      })
      .catch((e) => setIsLoading(false));
  }, [dispatch, params]);

  const addComponent = () => {
    navigate("/addinvoices");
  };

  const updateComponent = (id) => {
    navigate(`/updateinvoices/${id}`);
  };

  const deleteComponent = () => {
    if (currentComponent && currentComponent.id) {
      dispatch(deleteOneInvoice(currentComponent?.id));
    } else {
      console.error("No valid ID found for the component to delete.");
    }
  };

  const handleZatcaDetails = (zat) => {
    setZatDetails(zat);
    setZatcaMod(true);
  };

  const handleAccountingClassification = async (item) => {
    const markAsTesting = !Boolean(item?.is_testing_document);
    const confirmed = await swal({
      title: markAsTesting ? "Mark this document as testing?" : "Mark this document as real?",
      text: markAsTesting
        ? "It will stay stored and keep its ZATCA history, but it will be hidden from normal accounting lists and reports."
        : "It will be included in normal accounting lists and reports.",
      icon: "warning",
      buttons: ["Cancel", markAsTesting ? "Mark Testing" : "Mark Real"],
      dangerMode: markAsTesting,
    });
    if (!confirmed) {
      return;
    }

    setIsLoading(true);
    try {
      const response = await dispatch(
        updateInvoiceAccountingClassification(item.id, markAsTesting)
      );
      if (!response?.data?.status) {
        throw new Error(response?.data?.message || "Unable to update classification");
      }
      await dispatch(getInvoiceList(params));
      await swal({
        text: markAsTesting
          ? "Document classified as testing."
          : "Document classified as real.",
        icon: "success",
        button: "Close",
        timer: 1500,
      });
    } catch (error) {
      await swal({
        text:
          error?.response?.data?.message ||
          error?.message ||
          "Unable to update classification.",
        icon: "error",
        button: "Close",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="py-3">
      {isloading ? (
        <FullScreenLoader />
      ) : (
        <div>
          <Modal isOpen={modals} toggle={() => setModals(!modals)}>
            <InvoiceFilters
              modal={modals}
              setModal={setModals}
              params={params}
              setParams={setParams}
              invoiceType=""
            />
          </Modal>
          <CardHeader
            params={params}
            headerTitle="Invoice List"
            setParams={setParams}
            addmodel={addComponent}
            search={search}
            setOpenFilter={setOpenFilter}
            modals={modals}
            setModals={setModals}
          />

          <CardBody className="table-sec px-3">
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Company</th>
                  <th scope="col">Invoice Number</th>
                  <th scope="col">Environment</th>
                  <th scope="col">Accounting</th>
                  <th scope="col">Email Id</th>
                  <th scope="col">Mobile Number</th>
                  <th scope="col">Invoice Type</th>
                  <th scope="col">Date</th>
                  <th scope="col">Invoice Total(SAR)</th>
                  <th scope="col">ZATCA Integration</th>
                  <th scope="col">Reported</th>
                  <th scope="col">Signed</th>
                  <th scope="col" className="text-center">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {invoiceList?.invoices?.length > 0 ? (
                  invoiceList?.invoices?.map((item, index) => (
                    <tr key={index}>
                      <td> {index + 1 + (params?.page - 1) * 10}</td>
                      <td>{item?.company_name} </td>
                      <td>{item?.invoice_number} </td>
                      <td>
                        <span className={`sf-env-badge ${item?.is_test ? "sandbox" : "live"}`}>
                          {item?.is_test ? "TEST" : "LIVE"}
                        </span>
                      </td>
                      <td>
                        <span
                          className={`sf-env-badge ${
                            item?.is_testing_document ? "sandbox" : "live"
                          }`}
                        >
                          {item?.is_testing_document ? "TESTING" : "REAL"}
                        </span>
                      </td>
                      <td>{item?.email_id} </td>
                      <td>
                        {item?.country_code} {item?.mobile_number}{" "}
                      </td>

                      <td>
                        {item?.invoice_type == 0
                          ? "Simplified"
                          : item?.invoice_type == 1
                          ? "VAT"
                          : item?.invoice_type == 2
                          ? "Purchase"
                          : ""}{" "}
                      </td>
                      <td>{item?.date_time || "--"}</td>
                      <td>{item?.total} </td>
                      <td>{item?.onboarding===1?" Phase 2":" Phase 1"}</td>

                      <td>
                        {" "}
                       { item?.onboarding !==1 ?<h5>--</h5>:<img
                          src={item?.zatca_status == "REPORTED" ? Check : Cross}
                          alt=""
                        />}{" "}
                      </td>
                      <td>
                        {" "}
                        {item?.onboarding !== 1 ?<h5>--</h5>:<img
                          src={item?.signed_xml_url ? Check : Cross}
                          alt=""
                        />}{" "}
                      </td>
                      <td>
                        <div
                          className="d-flex align-items-center justify-content-center"
                          style={{ columnGap: "10px" }}
                        >
                          <button
                            className="border-button"
                            onClick={() => handleZatcaDetails(item)}
                          >
                            <span>ZATCA</span>
                          </button>
                          <button
                            className={
                              item?.is_testing_document
                                ? "border-button"
                                : "background-button"
                            }
                            onClick={() => handleAccountingClassification(item)}
                          >
                            <span>
                              {item?.is_testing_document
                                ? "Mark Real"
                                : "Mark Testing"}
                            </span>
                          </button>
                          {/* <button
                            className="border-button"
                            onClick={() => updateComponent(item?.id)}
                          >
                            <span>Update</span>
                          </button>
                          <button
                            className="background-button"
                            onClick={() => {
                              setModal(true);
                              setCurrentComponent(item);
                            }}
                          >
                            <span>Delete</span>
                          </button> */}
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="14" className="text-center">
                      No Invoices Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </CardBody>
          <CommonPagination
            params={params}
            setParams={setParams}
            pagination_meta={invoiceList?.pagination_meta}
          />
          <Modal isOpen={modal} toggle={() => setModal((state) => !state)}>
            <DeleteInvoices
              modalTitle={"Invoice"}
              itemType="invoice"
              setModal={setModal}
              currentComponent={currentComponent}
              deleteComponent={deleteComponent}
            ></DeleteInvoices>
          </Modal>
          <Modal 
            size="lg"
            isOpen={zatcaMod} 
            toggle={() => setZatcaMod(true)}
            >
            <ZatcaModals
              zatcaMod={zatcaMod}
              setZatcaMod={setZatcaMod}
              data={zatDetails}
            />
          </Modal>
        </div>
      )}
    </div>
  );
};

export default InvoiceLists;
